import { handleActions } from 'redux-actions';

import * as types from './actionTypes';

const initialState = {
	activeStateIds: [],
	usedStateIds: [],
	enableSave: false,
};

const reducerMap = {
	[types.SET_CAMPAIGN_STATE]: (state, { payload }) => {
		return {
			...state,
			activeStateIds: payload.states.map((state) => state.statusId),
			usedStateIds: payload.states.filter((state) => state.used).map((state) => state.statusId),
			enableSave: false,
		};
	},
	[types.UPDATE_CAMPAIGN_STATES]: (state, { payload }) => {
		return {
			...state,
			activeStateIds: payload.ids,
			enableSave: true,
		};
	},
	[types.ADD_CAMPAIGN_STATE]: (state, { payload }) => {
		return {
			...state,
			activeStateIds: state.activeStateIds.concat(payload.statusId),
			enableSave: true,
		};
	},
	[types.REMOVE_CAMPAIGN_STATE]: (state, { payload }) => {
		return {
			...state,
			activeStateIds: state.activeStateIds.filter((statusId) => statusId !== payload.statusId),
			enableSave: true,
		};
	},
	[types.ENABLE_SAVE]: (state, { payload }) => {
		return {
			...state,
			enableSave: payload.enable,
		};
	},
};

export default handleActions(reducerMap, initialState);
